import { render, staticRenderFns } from "./TaskTagFilter.vue?vue&type=template&id=c167fe28&scoped=true"
import script from "./TaskTagFilter.vue?vue&type=script&lang=ts"
export * from "./TaskTagFilter.vue?vue&type=script&lang=ts"
import style0 from "./TaskTagFilter.vue?vue&type=style&index=0&id=c167fe28&prod&lang=scss&scoped=true"
import style1 from "./TaskTagFilter.vue?vue&type=style&index=1&id=c167fe28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c167fe28",
  null
  
)

export default component.exports